import {
    ChatBubbleLeftIcon,
    ClipboardDocumentListIcon,
    EnvelopeIcon,
} from "@heroicons/react/24/outline";
import { useTaskNouns } from "hooks/use-task-nouns";
import React from "react";
import {
    actionKindLabel,
    WizardActionKind,
    WorkflowActionChip,
    workflowActionChips,
    WorkflowChipSource,
} from "./builder-helper";

interface SequenceStripProps {
    workflow: WorkflowChipSource;
}

interface ActionChipProps {
    chip: WorkflowActionChip;
}

interface ActionKindIconProps {
    kind: WizardActionKind;
    className: string;
}

export const ActionKindIcon: React.FC<ActionKindIconProps> = props => {
    const { kind, className } = props;

    switch (kind) {
        case "email":
            return <EnvelopeIcon className={className} />;
        case "sms":
            return <ChatBubbleLeftIcon className={className} />;
        case "task":
            return <ClipboardDocumentListIcon className={className} />;
    }
};

export const ActionChip: React.FC<ActionChipProps> = props => {
    const { chip } = props;
    const nouns = useTaskNouns();

    return (
        <span className="inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-2.5 py-1 text-xs">
            <ActionKindIcon kind={chip.kind} className="w-3.5 h-3.5 text-gray-500" />
            <span className="font-medium text-gray-700">
                {actionKindLabel(chip.kind, nouns)}
            </span>
            {chip.delayLabel ? (
                <>
                    <span className="text-gray-300">&middot;</span>
                    <span className="text-gray-500">{chip.delayLabel}</span>
                </>
            ) : null}
        </span>
    );
};

export const SequenceStrip: React.FC<SequenceStripProps> = props => {
    const { workflow } = props;
    const chips = workflowActionChips(workflow);

    if (chips.length === 0) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 flex-wrap">
            {chips.map((chip, index) => (
                <ActionChip key={index} chip={chip} />
            ))}
        </div>
    );
};
